import Repository from './Repository'
const resource = '/masters'

export default {
  /**
   * マスター情報を取得する
   */
  async get() {
    return await Repository.get(`${resource}/all`)
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
  /**
   * 西暦と和暦を併記したラベルと値から成る年リストを取得する
   * @param {Number} future 未来取得年数
   * @param {Number} past 過去取得年数
   */
  async getYears(future, past) {
    const params = { future: future, past: past }
    return await Repository.get(`${resource}/years`, { params: params })
      .then(response => {
        return response.data.body
      })
      .catch(e => {
        console.log(e)
      })
  },
}
